import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { translation } from 'apis';
import { common as elCommon } from './el';
import { common as enCommon } from './en';

export const lazyLoadTranslations = async () => {
    const data = await translation.getResources();
    data?.map((lang) => {
        i18n.addResourceBundle(lang.ln, lang.namespace, lang.datavalues, true, false);
        return null;
    });
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        partialBundledLanguages: true,
        transSupportBasicHtmlNodes: true,
        fallbackLng: 'el',
        defaultNS: 'common',
        interpolation: {
            escapeValue: false
        },
        resources: {
            el: { common: elCommon },
            en: { common: enCommon }
        }
    });

export default i18n;
